<template>
  <div :class="[{ chat: !useRem, useRem, isGame }]">
    <div class="chat__container">
      <div
        v-for="item in data"
        :key="`${item.n}${item.time}`"
        class="chat-item"
        :class="[
          `type-${item.type}`,
          {
            'chat-item-opacity': opactiyBG && canShowType(item),
            'chat-item-hide':
              !chatEventValus.includes(item.type) &&
              item.type !== 'init' &&
              item.type !== 'welcome'
          }
        ]"
      >
        <div class="chat-item-inner">
          <template v-if="item.type === 'init'">
            <div>{{ $t('lang031') }}</div>
          </template>
          <template v-if="item.type === 'welcome'">
            <div>{{ $t('lang338') }}</div>
          </template>
          <template v-if="item.type === 'blank'">
            <div class="blank"></div>
          </template>
          <!-- 4/5/11 -->
          <template
            v-else-if="
              item.m &&
                (item.type === CHAT_EVENT.ROOM_OWNER_LEAVE_TEXT ||
                  item.type === CHAT_EVENT.ROOM_OWNER_BACK_TEXT ||
                  item.type === CHAT_EVENT.ANNOUNCE_TEXT)
            "
          >
            <span class="user-text-content">{{ item.m }}</span>
          </template>
          <!-- 1/2/3/6/8/10 -->
          <template v-else-if="chatEventValus.includes(item.type)">
            <div
              :class="['user-grade', { 'user-grade-34': +item.grade >= 34 }]"
              :style="{
                backgroundImage: `url(${switchGradeImage(item.grade)})`
              }"
            >
              <!-- 不要换行 -->
              <span v-if="+item.grade < 34">Lv.</span>{{ item.grade }}
            </div>
            <span class="user-name">{{ item.n || item.m }}</span>
            <i class="user-name-sep">:</i>
            <!-- 评论信息 -->
            <span class="user-text-content">
              <!-- 3 -->
              <template v-if="item.type === CHAT_EVENT.LIGHT_MY_HEART_TEXT">
                <span>sent</span>
                <img :src="require('~/assets/img/like.png')" alt="" />
              </template>
              <!-- 6 -->
              <template v-if="item.type === CHAT_EVENT.NORMAL_GIFT_TEXT">
                <span>sent a {{ getGiftName(item.m) }}</span>
                <img :src="getGiftIconUrl(item.m)" />
                <span>X{{ item.c }}</span>
              </template>
              <!-- 8 -->
              <span v-if="item.type === CHAT_EVENT.FOLLOW_OWNER_TEXT">
                became a Fan.Won't miss the next LIVE
              </span>
              <!-- 10 -->
              <span v-if="item.type === CHAT_EVENT.SHARE_LIVING_TEXT">
                shared this LIVE
              </span>
              <!-- 1/2 -->
              <template v-if="comments.includes(item.type)">
                {{ item.m }}
              </template>
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import PlayerWs from '~/components/Player/playerWs';

export default {
  name: 'Chat',
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    },
    opactiyBG: Boolean,
    useRem: Boolean,
    isGame: Boolean
  },
  data() {
    this.CHAT_EVENT = PlayerWs.CHAT_EVENT;
    return {};
  },
  computed: {
    chatEventValus() {
      return Object.values(this.CHAT_EVENT);
    },
    comments() {
      const { NORMAL_TEXT, DAMMARKU_TEXT } = this.CHAT_EVENT;
      return [NORMAL_TEXT, DAMMARKU_TEXT];
    }
  },
  watch: {
    data() {
      // 小与100自动滑到底部
      const target = document.querySelector('.chat__container');
      if (target) {
        const scrollTop = target.scrollTop;
        const scrollHeight = target.scrollHeight;
        const clientHeight = target.clientHeight;
        if (scrollHeight - scrollTop - clientHeight < 100) {
          this.$nextTick(() => {
            target.scrollTop = target.scrollHeight;
          });
        }
      }
    }
  },
  methods: {
    canShowType(item) {
      if (
        item.type === 'init' ||
        item.type === this.CHAT_EVENT.ROOM_OWNER_LEAVE_TEXT ||
        item.type === this.CHAT_EVENT.ROOM_OWNER_BACK_TEXT ||
        item.type === this.CHAT_EVENT.ANNOUNCE_TEXT ||
        this.chatEventValus.includes(item.type)
      ) {
        return true;
      }
      return false;
    },
    getGiftName(giftId) {
      // 复用giftAnimation.js 请求过的礼物列表
      const { giftJSONLikeArr = [] } = window;
      const gift = giftJSONLikeArr.find((it) => +it.typeid === +giftId);
      return gift?.name;
    },
    getGiftIconUrl(giftId) {
      const { giftJSONLikeArr = [] } = window;
      const gift = giftJSONLikeArr.find((it) => +it.typeid === +giftId);
      if (gift && window.location.origin.includes('bigoapp.tv')) {
        gift.img_url =
          gift.img_url &&
          gift.img_url.replace('giftesx.bigo.sg', 'giftesx.piojm.tech');
      }
      return gift?.img_url;
    },
    switchGradeImage(lev) {
      // 返回的是字符串
      lev = +lev;

      let index = 1;
      if (lev < 11) {
        index = 1;
      } else if (lev < 23) {
        index = 11;
      } else if (lev < 34) {
        index = 23;
      } else if (lev < 45) {
        index = 34;
      } else if (lev < 56) {
        index = 45;
      } else if (lev < 67) {
        index = 56;
      } else if (lev < 78) {
        index = 67;
      } else if (lev < 89) {
        index = 78;
      } else {
        index = 89;
      }
      return require(`@assets/mobile/images/level/${index}.png`);
    }
  }
};
</script>

<style lang="scss" scoped>
@function pxTorem($px) {
  //$px为需要转换的字号
  @return $px / 75 * 1rem;
}

.chat {
  height: 100%;
  direction: ltr;
  border-radius: 4px;
  background-color: #fff;

  .chat__container {
    padding: 10px;
    height: 100%;
    overflow: auto;
  }

  .chat-item {
    margin-bottom: 10px;
    overflow: hidden;
    font-size: 14px;
    color: #8a8f99;
    font-weight: 500;
    line-height: 18px;

    &.chat-item-hide {
      margin-bottom: 0;
    }

    .user-grade {
      display: inline-block;
      text-align: center;
      width: 41px;
      height: 18.7px;
      font-size: 13px;
      color: #ffffff;
      line-height: 18.7px;
      margin-right: 4px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      padding: 1px 0;
      vertical-align: middle;

      span {
        display: inline-block;
        height: 100%;
        line-height: 18.7px;
      }

      &.user-grade-34 {
        padding-left: 11px;
      }
    }

    .user-name,
    .user-name-sep {
      vertical-align: middle;
    }

    .user-text-content {
      vertical-align: middle;
      color: #2f3033;

      > * {
        vertical-align: middle;
      }

      img {
        max-height: 30px;
      }
    }

    &.type-2,
    &.type-3,
    &.type-4,
    &.type-6,
    &.type-8,
    &.type-10,
    &.type-11 {
      .user-text-content {
        color: #00decb;
      }
    }
  }
}

.useRem {
  width: 100%;
  height: 100%;
  direction: ltr;

  .chat__container {
    padding: pxTorem(10);
    height: 100%;
    overflow: auto;
  }

  .chat-item {
    margin-bottom: pxTorem(8);
    color: rgba(255, 255, 255, 0.8);
    font-size: pxTorem(28);
    font-weight: 500;
    line-height: pxTorem(34);
    overflow: hidden;

    .blank {
      margin-bottom: pxTorem(270);
    }

    &.chat-item-hide {
      margin-bottom: 0 !important;
    }

    &.chat-item-opacity {
      display: block;

      .chat-item-inner {
        background: rgba(0, 0, 0, 0.3);
        border-radius: pxTorem(28);
        padding: pxTorem(8) pxTorem(14);
        display: inline-block;
        max-width: pxTorem(600);
      }
    }

    .user-grade {
      display: inline-block;
      text-align: center;
      width: pxTorem(62);
      height: pxTorem(28);
      font-size: pxTorem(20);
      color: #ffffff;
      line-height: pxTorem(28);
      margin-right: pxTorem(8);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      padding: pxTorem(1) 0;
      vertical-align: middle;
      margin-bottom: pxTorem(3); // (34-28)/2 实现垂直居中

      span {
        display: inline-block;
        height: 100%;
        line-height: pxTorem(28);
      }

      &.user-grade-34 {
        padding-left: pxTorem(22);
      }
    }

    .user-name,
    .user-name-sep {
      vertical-align: middle;
    }

    .user-text-content {
      color: #ffffff;
      vertical-align: middle;

      > * {
        vertical-align: middle;
      }

      img {
        max-height: pxTorem(28);
      }
    }

    &.type-2,
    &.type-3,
    &.type-4,
    &.type-6,
    &.type-8,
    &.type-10,
    &.type-11 {
      .user-text-content {
        color: #00decb;
      }
    }
  }

  &.isGame {
    .chat-item {
      margin-bottom: pxTorem(20);
      color: #8a8f99;

      .user-text-content {
        color: #2f3033;
      }

      &.type-2,
      &.type-3,
      &.type-4,
      &.type-6,
      &.type-8,
      &.type-10,
      &.type-11 {
        .user-text-content {
          color: #00decb;
        }
      }

      &.type-welcome {
        color: #c4c7cb;
      }
    }
  }
}
</style>
